export { FrequentlyAskedQuestionsAccordion } from './FrequentlyAskedQuestionsAccordion';
